import Vue from "vue";
import store from "@/store";
import { toReauth, refreshToken } from "@/utils";

/**
 * requestInterceptor
 * @description Intercepts requests sent to Identity server
 */
export const requestInterceptor = async config => {
  try {
    const keycloak = Vue.prototype.$keycloak;
    await refreshToken();
    const token = keycloak.token;

    if (token) config.headers["Authorization"] = 'Bearer ' + token;

    return config;
  } catch {
    return config;
  }
};

/**
 * responseInterceptor
 * @description Intercepts request response error cases  
 */
export const responseInterceptor = async error => {
  if (error.response || error.request) {
    const data = error.response || error.request;
    switch (data.status) {
      case 401:
        toReauth();
        break;
    }
  }
  return  Promise.reject(error)
};
